/**
 * Component for parsing and rendering an encoded Polyline on a Google Map.
 * https://developers.google.com/maps/documentation/utilities/polylinealgorithm
 */

import React from 'react';

import { wrappedPromise } from 'app/client/google/utils';

type PolylineProps = {
  map: google.maps.Map | null;
  path: string | null;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
};

export class Polyline extends React.Component<PolylineProps> {
  static displayName = 'Polyline';

  static defaultProps: Partial<PolylineProps> = {
    map: null,
    path: null,
    strokeColor: '#189c88',
    strokeOpacity: 1.0,
    strokeWeight: 4,
  };

  polyline?: google.maps.Polyline;
  markerPromise?: ReturnType<typeof wrappedPromise>;

  componentDidMount() {
    this.markerPromise = wrappedPromise();
    this.renderPolyline();
  }

  componentDidUpdate(prevProps: PolylineProps) {
    const { map, path } = this.props;
    if (map !== prevProps.map || path !== prevProps.path) {
      if (this.polyline) {
        this.polyline.setMap(null);
      }
      this.renderPolyline();
    }
  }

  componentWillUnmount() {
    if (this.polyline) {
      this.polyline.setMap(null);
    }
  }

  renderPolyline() {
    const { map, path, strokeColor, strokeOpacity, strokeWeight } = this.props;

    if (!path) {
      return this.markerPromise?.resolve(null as unknown as google.maps.Polyline);
    }

    this.polyline = new window.google.maps.Polyline({
      path: window.google.maps.geometry.encoding.decodePath(path),
      geodesic: true,
      map,
      strokeColor,
      strokeOpacity,
      strokeWeight,
    });

    this.markerPromise?.resolve(this.polyline);
  }

  render() {
    return null;
  }
}

export default Polyline;
